export default "__VITE_ASSET__a27ab4d5__"